<template lang="pug">
.m-card
  .m-card-header(:id="'heading-oxt-' + id" :data-bs-target="'#collapse-oxt-' + id" :aria-controls="'collapse-oxt-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_1X2", 1) }}
  .m-card-body.collapse.show(:id="'collapse-oxt-' + id" :aria-labelledby="'heading-oxt-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group            
            .row
              template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][5] != 0 && details['oxt'][0][5] != ''")
                OddsItem.col(:odds="details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" homeAway="1" mode="oxt")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][7] != 0 && details['oxt'][0][7] != ''")
                OddsItem.col(:odds="details['oxt'][0]" idx=7 :typ="oddsType" dataType="2" homeAway="2" mode="oxt")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][6] != 0 && details['oxt'][0][6] != ''")
                OddsItem.col(:odds="details['oxt'][0]" idx=6 :typ="oddsType" dataType="2" homeAway="3" mode="oxt")
              template(v-else)
                OddsDisabled.col

        .odds-wrapper(v-if="$helpers.objSize(details['oxth']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T
          .odds-group
            .row
              template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][5] != 0 && details['oxth'][0][5] != ''")
                OddsItem.col(:odds="details['oxth'][0]" idx=5 :typ="oddsType" dataType="2" homeAway="1" mode="oxth")
              template(v-else)
                OddsDisabled.col

              template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][7] != 0 && details['oxth'][0][7] != ''")
                OddsItem.col(:odds="details['oxth'][0]" idx=7 :typ="oddsType" dataType="2" homeAway="2" mode="oxth")
              template(v-else)
                OddsDisabled.col

              template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][6] != 0 && details['oxth'][0][6] != ''")
                OddsItem.col(:odds="details['oxth'][0]" idx=6 :typ="oddsType" dataType="2" homeAway="3" mode="oxth")
              template(v-else)
                OddsDisabled.col

//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-oxt-' + childId"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-oxt-' + childId"
//-     :aria-controls="'collapse-oxt-' + childId"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_1X2", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-oxt-' + childId"
//-     :id="'collapse-oxt-' + childId"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Home") }}
//-                 template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][5] != 0 && details['oxt'][0][5] != ''")
//-                   OddsItem(:odds="details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Away") }}
//-                 template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][7] != 0 && details['oxt'][0][7] != ''")
//-                   OddsItem(:odds="details['oxt'][0]" idx=7 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Draw") }}
//-                 template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][6] != 0 && details['oxt'][0][6] != ''")
//-                   OddsItem(:odds="details['oxt'][0]" idx=6 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
//-         .normal(v-if="$helpers.objSize(details['oxth']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Home") }}
//-                 template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][5] != 0 && details['oxth'][0][5] != ''")
//-                   OddsItem(:odds="details['oxth'][0]" idx=5 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Away") }}
//-                 template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][7] != 0 && details['oxth'][0][7] != ''")
//-                   OddsItem(:odds="details['oxth'][0]" idx=7 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Draw") }}
//-                 template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][6] != 0 && details['oxth'][0][6] != ''")
//-                   OddsItem(:odds="details['oxth'][0]" idx=6 :typ="oddsType" dataType="2" :details="details")
//-                 template(v-else)
//-                   OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    },
    childId: {
      type: Number
    }
  }
}
</script>
